var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(852 2201)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-849 -2197.818)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.405,23.206H4.8a2.8,2.8,0,0,1-2.8-2.8V7.8A2.8,2.8,0,0,1,4.8,5h6.3a1,1,0,0,1,0,2H4.8a.8.8,0,0,0-.8.8v12.6a.8.8,0,0,0,.8.8h12.6a.8.8,0,0,0,.8-.8V14.1a1,1,0,0,1,2,0v6.3A2.8,2.8,0,0,1,17.405,23.206Z",
    transform: "translate(0 -1.272)",
    fill: "#494d7d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8,1.818a2.91,2.91,0,0,1,2.058,4.967l-8.553,8.553a1,1,0,0,1-.465.263l-3.6.9a1,1,0,0,1-1.213-1.213l.9-3.6a1,1,0,0,1,.263-.465L20.746,2.67A2.891,2.891,0,0,1,22.8,1.818ZM15.09,13.728l8.357-8.357A.91.91,0,0,0,22.16,4.085L13.8,12.442l-.429,1.716Z",
    transform: "translate(-3.598)",
    fill: "#494d7d"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    transform: "translate(-852 -2201)",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.d491fd438d015f9e1343c4f8f8423cf2.svg";
export { ForwardRef as ReactComponent };